import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Leaf, LogOut } from "lucide-react";
import HeroSlidesPanel from "@/components/admin/HeroSlidesPanel";
import ProductsPanel from "@/components/admin/ProductsPanel";
import CategoriesPanel from "@/components/admin/CategoriesPanel";
import OffersPanel from "@/components/admin/OffersPanel";
import AnalyticsPanel from "@/components/admin/AnalyticsPanel";
import OrdersPanel from "@/components/admin/OrdersPanel";
import SettingsPanel from "@/components/admin/SettingsPanel";

export default function AdminDashboard() {
  const nav = useNavigate();
  const [email, setEmail] = useState(localStorage.getItem("ng_admin_email") || "");

  useEffect(() => {
    if (!localStorage.getItem("ng_admin_token")) {
      nav("/admin/login");
      return;
    }
    api.get("/auth/me").then((r) => setEmail(r.data.email)).catch(() => {
      localStorage.removeItem("ng_admin_token");
      nav("/admin/login");
    });
  }, [nav]);

  const logout = () => {
    localStorage.removeItem("ng_admin_token");
    localStorage.removeItem("ng_admin_email");
    nav("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#F4F4F5]">
      {/* Top bar */}
      <header className="bg-white border-b border-black/10">
        <div className="max-w-[1400px] mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-md bg-white border border-black/10 flex items-center justify-center overflow-hidden">
              <img
                src="https://customer-assets-lqy194kg.emergentagent.net/job_produce-hub-97/artifacts/apfk1p9h_Saravana_Stores_HQ.png"
                alt="Saravana Stores"
                className="w-full h-full object-contain"
              />
            </div>
            <div>
              <div className="text-sm font-semibold text-charcoal">Saravana Stores</div>
              <div className="text-[10px] uppercase tracking-[0.28em] text-charcoal/50">Farmer's Market · Admin</div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs text-charcoal/60 hidden sm:block" data-testid="admin-email">{email}</span>
            <Button variant="outline" size="sm" onClick={logout} data-testid="logout-btn">
              <LogOut className="w-3.5 h-3.5 mr-1.5" /> Sign out
            </Button>
          </div>
        </div>
      </header>

      <main className="max-w-[1400px] mx-auto px-6 py-8">
        <Tabs defaultValue="products" className="w-full">
          <TabsList className="bg-white border border-black/10 h-11 p-1 rounded-md flex flex-wrap">
            <TabsTrigger value="products" data-testid="tab-products" className="text-sm">Products</TabsTrigger>
            <TabsTrigger value="categories" data-testid="tab-categories" className="text-sm">Categories</TabsTrigger>
            <TabsTrigger value="offers" data-testid="tab-offers" className="text-sm">Offers</TabsTrigger>
            <TabsTrigger value="hero" data-testid="tab-hero" className="text-sm">Homepage</TabsTrigger>
            <TabsTrigger value="analytics" data-testid="tab-analytics" className="text-sm">Analytics</TabsTrigger>
            <TabsTrigger value="orders" data-testid="tab-orders" className="text-sm">Orders</TabsTrigger>
            <TabsTrigger value="settings" data-testid="tab-settings" className="text-sm">Settings</TabsTrigger>
          </TabsList>

          <TabsContent value="products" className="mt-6"><ProductsPanel /></TabsContent>
          <TabsContent value="categories" className="mt-6"><CategoriesPanel /></TabsContent>
          <TabsContent value="offers" className="mt-6"><OffersPanel /></TabsContent>
          <TabsContent value="hero" className="mt-6"><HeroSlidesPanel /></TabsContent>
          <TabsContent value="analytics" className="mt-6"><AnalyticsPanel /></TabsContent>
          <TabsContent value="orders" className="mt-6"><OrdersPanel /></TabsContent>
          <TabsContent value="settings" className="mt-6"><SettingsPanel /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
